import React from 'react';
import './App.css';
import MainUIElements from "../features/viewer/components/MainUI";

class App extends React.Component {
  render() {
    return <div>
      <MainUIElements/>
    </div>

  }
}

export default App;
